/*
This file contains the storm scenario configurations for the map
*/

export const stormScenarios = [
 // NO ADAPTATIONS
 {
  title: "Baseline Scenario RP30", // title of the baseline tile layer
  SLR: "Current", // SLR button text
  stormSurge: "No Surge", // Storm Surge button text
  groudwaterConditions: "Variable GW", // Groundwater Condition selection (not shown)
  rainfallAmount: "5-yr", // Rainfall Amount button text
  adaptationScenario: "None", // Adaptation Scenario text
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP30/MapServer",
 },
 {
  title: "Baseline Scenario RP46",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "10-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP46/MapServer",
 },
 {
  title: "Baseline Scenario RP42",
  SLR: "Current",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP42/MapServer",
 },
 {
  title: "Baseline Scenario RP47",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP47/MapServer",
 },
 {
  title: "Baseline Scenario RP49",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP49/MapServer",
 },
 {
  title: "Baseline Scenario RP35",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP35/MapServer",
 },
 {
  title: "Baseline Scenario RP4",
  SLR: "2.0 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP4/MapServer",
 },
 {
  title: "Baseline Scenario RP2",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP2/MapServer",
 },
 {
  title: "Baseline Scenario RP3",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP3/MapServer",
 },
 {
  title: "Baseline Scenario RP6",
  rainfallAmount: "100-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Saturated System",
  stormSurge: "20-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP6/MapServer",
 },
 {
  title: "Baseline Scenario RP7",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP7/MapServer",
 },
 {
  title: "Baseline Scenario RP8",
  rainfallAmount: "50-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP8/MapServer",
 },
 {
  title: "Baseline Scenario RP9",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP9/MapServer",
 },
 {
  title: "Baseline Scenario RP38",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP38/MapServer",
 },
 {
  title: "Baseline Scenario RP10",
  rainfallAmount: "25-yr",
  SLR: "3.3 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "No Surge",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP10/MapServer",
 },
 {
  title: "Baseline Scenario RP11",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP11/MapServer",
 },
 {
  title: "Baseline Scenario RP12",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP12/MapServer",
 },
 {
  title: "Baseline Scenario RP13",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP13/MapServer",
 },
 {
  title: "Baseline Scenario RP15",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP15/MapServer",
 },
 {
  title: "Baseline Scenario RP16",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP16/MapServer",
 },
 {
  title: "Baseline Scenario RP17",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP17/MapServer",
 },
 {
  title: "Baseline Scenario RP18",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "None",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Baseline_Scenario_RP18/MapServer",
 }, // END NO ADAPTATIONS

 // AS5 aka Tier 1
 {
  title: "Adaptation Suite AS5 RP30",
  SLR: "Current",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP30/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP46",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "10-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP46/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP42",
  SLR: "Current",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP42/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP47",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP47/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP49",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP49/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP35",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP35/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP4",
  SLR: "2.0 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP4/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP2",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP2/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP3",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP3/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP6",
  rainfallAmount: "100-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Saturated System",
  stormSurge: "20-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP6/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP7",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP7/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP8",
  rainfallAmount: "50-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP8/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP9",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP9/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP38",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP38/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP10",
  rainfallAmount: "25-yr",
  SLR: "3.3 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "No Surge",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP10/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP11",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP11/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP12",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP12/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP13",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP13/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP15",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP15/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP16",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP16/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP17",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP17/MapServer",
 },
 {
  title: "Adaptation Suite AS5 RP18",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 1",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5_RP18/MapServer",
 }, // END AS5

 // AS5B aka Tier 2
 {
  title: "Adaptation Suite AS5b RP30",
  SLR: "Current",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP30/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP46",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "10-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP46/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP42",
  SLR: "Current",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP42/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP47",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP47/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP49",
  SLR: "Current",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP49/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP35",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP35/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP4",
  SLR: "2.0 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP4/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP2",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP2/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP3",
  SLR: "2.0 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP3/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP6",
  rainfallAmount: "100-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Saturated System",
  stormSurge: "20-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP6/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP7",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP7/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP8",
  rainfallAmount: "50-yr",
  SLR: "2.0 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP8/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP9",
  SLR: "2.0 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP9/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP38",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "5-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP38/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP10",
  rainfallAmount: "25-yr",
  SLR: "3.3 ft",
  groudwaterConditions: "Variable GW",
  stormSurge: "No Surge",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP10/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP11",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP11/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP12",
  SLR: "3.3 ft",
  stormSurge: "No Surge",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP12/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP13",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP13/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP15",
  SLR: "3.3 ft",
  stormSurge: "20-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP15/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP16",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "25-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP16/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP17",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Variable GW",
  rainfallAmount: "50-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP17/MapServer",
 },
 {
  title: "Adaptation Suite AS5b RP18",
  SLR: "3.3 ft",
  stormSurge: "100-yr",
  groudwaterConditions: "Saturated System",
  rainfallAmount: "100-yr",
  adaptationScenario: "Tier 2",
  tileURL:
   "https://tiles.arcgis.com/tiles/JMAJrTsHNLrSsWf5/arcgis/rest/services/Adaptation_Suite_AS5b_RP18/MapServer",
 },
 // END AS5B
];
